import { useLanguage } from "./LanguageContext";

interface DashboardHeaderProps {
  userName: string;
  userType: string;
}

export function DashboardHeader({ userName, userType }: DashboardHeaderProps) {
  const { t, language } = useLanguage();
  
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (language === 'es') {
      if (hour < 12) return "Buenos días";
      if (hour < 18) return "Buenas tardes";
      return "Buenas noches";
    } else {
      if (hour < 12) return "Good morning";
      if (hour < 18) return "Good afternoon";
      return "Good evening";
    }
  };

  return (
    <div className="py-6">
      {/* Greeting */}
      <div>
        <h1 className="text-2xl font-semibold text-gray-900 mb-1">
          {getGreeting()}, {userName}
        </h1>
        <p className="text-gray-600">
          {t("dashboard.overview")}
        </p>
      </div>
    </div>
  );
}